import { Brand } from "types/common";

export const DEFAULT_IMAGE_HOST = "cdn.media.amplience.net";
export const FACET_UPDATE_EVENT = "plp/facet-update";
export const GRID_UPDATE_EVENT = "plp/grid-update";
export const PLP_ROOT_ID = "product-listing-root";

export const BRAND_IMAGE_HOSTS_MAP = {
  [Brand.Very]: "media.very.co.uk",
  [Brand.VeryIE]: "media.very.ie",
  [Brand.Littlewoods]: "media.littlewoods.com",
};
